import get from "lodash/get";
import { GetScore, Lifter, Meet } from "types";
import { toKg } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isLbsMeet } from "util/meetHelper";
import { ageCoef } from "./age";

const parameters = {
  MALE: {
    a: -0.000001093,
    b: 0.0007391293,
    c: -0.1918759221,
    d: 24.0900756,
    e: -307.75076,
  },
  FEMALE: {
    a: -0.0000010706,
    b: 0.0005158568,
    c: -0.1126655495,
    d: 13.6175032,
    e: -57.96288,
  },
};

export const dotsCoef = function (lifter: Lifter, meet: Meet) {
  let bw = lifter.bodyWeight;

  if (!bw) {
    return 0;
  }

  if (!lifter.gender) {
    return 0;
  }

  // uses maxes
  // https://gitlab.com/openpowerlifting/opl-data/blob/main/crates/coefficients/src/dots.rs
  // https://www.ipfpointscalculator.com/
  // https://liftvault.com/resources/powerlifting-calculator/

  // doesn't use maxes
  // https://bitekit.app/tools/dots-score-calculator/
  // https://dotscalculator.com/
  // https://fitnessvolt.com/dots-calculator/
  // https://strengthorigins.com/dots-calculator/
  // https://strengthlevel.com/dots-calculator

  // doesn't allow values outside range.
  // https://concalculator.com/dots-calculator/

  // if (lifter.gender === "MALE") {
  //   bw = Math.min(Math.max(bw, 40.0), 210.0);
  // } else if (lifter.gender === "FEMALE") {
  //   bw = Math.min(Math.max(bw, 40.0), 150.0);
  // }

  if (isLbsMeet(meet)) {
    bw = toKg(bw);
  }

  const p = get(parameters, lifter.gender);
  if (!p) {
    return 0;
  }

  return (
    500.0 /
    (p.a * Math.pow(bw, 4) +
      p.b * Math.pow(bw, 3) +
      p.c * Math.pow(bw, 2) +
      p.d * bw +
      p.e)
  );
};

export const dotsFormula = function (
  total: number,
  lifter: Lifter,
  meet: Meet,
) {
  if (total <= 0) {
    return 0;
  }

  return total * dotsCoef(lifter, meet);
};

export const getDotsPoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return dotsFormula(total, lifter, meet);
};

export const getDotsAndAgePoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  return (
    getDotsPoints({ lifter, division, meet, forecasted }) *
    ageCoef(lifter, meet)
  );
};
